<template>
  <div class="room-sticker">
    <el-card>
      <el-row class="room-sticker__title">房间贴纸配置</el-row>
      <el-row class="room-sticker__search">
        <el-select v-model="searchData.valid" placeholder="是否有效" clearable="" filterable="">
          <el-option label="无效" :value="0"></el-option>
          <el-option label="有效" :value="1"></el-option>
        </el-select>
        <el-button type="primary" @click="queryStickerBtnHandle" :loading="requestLoading">
          查询
        </el-button>
        <el-button type="success" @click="addStickerBtnHandle"> 新增 </el-button>
        <el-button type="warning" @click="resetSearch"> 重置 </el-button>
      </el-row>
      <el-row>
        <el-table height="65vh" :data="stickerList" style="width: 100%" v-loading="requestLoading" border>
          <el-table-column prop="stickerTitle" label="贴纸标题" align="center">
          </el-table-column>
          <el-table-column prop="stickerText" label="贴纸文案" align="center">
          </el-table-column>
          <el-table-column prop="iconUrl" label="贴纸图" align="center" sortable>
            <template slot-scope="scope">
              <el-image style="width: 150px; height: auto" :src="scope.row.iconUrl"
                :preview-src-list="[scope.row.iconUrl]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="showUrl" label="贴纸预览图" align="center" sortable>
            <template slot-scope="scope">
              <el-image style="width: 150px; height: auto" :src="scope.row.showUrl"
                :preview-src-list="[scope.row.showUrl]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="valid" label="状态" align="center" sortable>
            <template slot-scope="scope">{{ scope.row.valid == 1 ? '有效' : '无效' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="editRowHandle(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-pagination :current-page.sync="pageInfo.page" layout="total, prev, pager, next" background
          @current-change="handleCurrentChange" :total="pageInfo.total" class="pagination" :page-size="30">
        </el-pagination>
      </el-row>
    </el-card>
    <el-dialog :title="isAddSticker ? '新增房间贴纸配置' : '编辑房间贴纸配置'" :visible.sync="dialogVisible" width="50%"
      :before-close="handleDialogClose">
      <div class="item">
        <span>贴纸标题</span>
        <el-input type="text" v-model="submitForm.stickerTitle"></el-input>
      </div>
      <div class="item">
        <span>贴纸文案</span>
        <el-input type="text" v-model="submitForm.stickerText"></el-input>
      </div>
      <div class="item">
        <span>贴纸图</span>
        <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
          :on-change="value => changFile(1, value)" ref="upload">
          <el-image v-if="submitForm.iconUrl !== ''" style="width: 178px; height: auto" :src="submitForm.iconUrl"
            fit="scale-down"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>贴纸预览图</span><el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false"
          :on-change="value => changFile(2, value)" ref="upload">
          <el-image v-if="submitForm.showUrl !== ''" style="width: 178px; height: auto" :src="submitForm.showUrl"
            fit="scale-down"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>是否有效</span>
        <el-switch v-model="submitForm.valid" active-text="有效" inactive-text="无效" :active-value="1"
          :inactive-value="0"></el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadReqBtnHandle(0)" type="primary" v-if="isAddSticker">
          新 增
        </el-button>
        <el-button v-loading="uploadProcess" @click="uploadReqBtnHandle(1)" type="primary" v-else>
          编 辑
        </el-button>
        <el-button @click="handleDialogClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 查询数据
      searchData: {
        valid: null
      },
      // 查询加载中
      requestLoading: false,
      // 总页数
      pageInfo: {
        page: 1,
        total: 0
      },
      // 数据列表
      stickerList: [],
      // 新增和修改时数据表单
      submitForm: {
        "id": null, //用于修改接口传值
        "stickerTitle": "", //贴纸标题
        "stickerText": "",//贴纸文案
        "iconUrl": "", //贴纸图片
        "showUrl": "", //贴纸预览图
        "valid": 1//状态 0无效 1有效
      },
      dialogVisible: false,
      isAddSticker: true,
      uploadProcess: false
    }
  },

  methods: {
    // 查询贴纸接口
    async stickerDataRequest() {
      this.requestLoading = true
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.room_sticker_query +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        {
          params: { ...this.searchData, page: 1 }
        }
      )
      this.stickerList = res.data.data
      this.pageInfo.total = res.data.total
      this.requestLoading = false
    },
    // 查询按钮处理
    queryStickerBtnHandle() {
      this.stickerDataRequest()
    },
    // 新增按钮处理
    addStickerBtnHandle() {
      this.isAddSticker = true
      this.dialogVisible = true
    },
    // 重置按钮处理
    resetSearch() {
      this.searchData.valid = null
      this.stickerDataRequest()
    },
    // 编辑行处理事件
    editRowHandle(row) {
      this.submitForm = {
        "id": row.id,
        "stickerTitle": row.stickerTitle,
        "stickerText": row.stickerText,
        "iconUrl": row.iconUrl,
        "showUrl": row.showUrl,
        "valid": row.valid,
      }
      this.isAddSticker = false
      this.dialogVisible = true
    },
    // 图片上传
    async changFile(type, file) {
      this.uploadProcess = true
      const formData = new FormData()
      formData.append('file', file.raw)
      formData.append('cover', 0)
      formData.append('dir', 'room_sticker/icon/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
        formData
      )
      this.uploadProcess = false
      if (res.code !== 0) {
        this.$refs.upload.clearFiles()
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type == 1) {
        this.submitForm.iconUrl = res.data
      } else if (type == 2) {
        this.submitForm.showUrl = res.data
      }
    },
    // 新增/修改提交按钮处理
    async uploadReqBtnHandle(label) {
      let url = null
      if (label === 0) {
        url =
          this.$store.getters.path.room_sticker_add +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        this.submitForm.id = null
      } else {
        url =
          this.$store.getters.path.room_sticker_edit +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
      }
      const { data: res } = await this.$axios.get(url, { params: this.submitForm })
      if (res.code != 0) return this.$message.error(res.msg)
      this.handleDialogClose()
      this.stickerDataRequest()
      this.$message.success(res.msg)
    },
    handleCurrentChange(index) {
      this.pageInfo.page = index
      this.stickerDataRequest()
    },

    // 弹窗关闭事件
    handleDialogClose() {
      this.submitForm = {
        "id": null,
        "stickerTitle": "",
        "stickerText": "",
        "iconUrl": "",
        "showUrl": "",
        "valid": 1
      }
      this.dialogVisible = false
    }
  },
  mounted() {
    this.stickerDataRequest()
  }
}

</script>
<style scoped lang="scss">
.room-sticker {
  &__title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
  }

  &__search {
    .el-select {
      margin-right: 10px;
    }
  }
}

.item {
  display: flex;
  margin: 10px 0;
  align-items: center;

  .el-input {
    margin-left: 10px;
  }

  span {
    width: 100px;
  }
}
</style>
